.tableHeader {
  display: block;
  position: sticky;
  backface-visibility: visible;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  background: var(--ixf-table-background-color);
  transition: none;
  will-change: top;

  .headerRow {
    border-top: var(--ixf-table-border);
    display: flex;

    &:last-child {
      border-bottom: var(--ixf-table-border);
    }
  }
}
